import { useEventBus } from '@vueuse/core'

export const evtBus = useEventBus<'open' | 'close'>(
  'selectTemplateDialogEvtBus'
)

export type EvtBusType = typeof evtBus

export type EvtBusListenerType = Parameters<EvtBusType['on']>[0]

export const open = () => {
  evtBus.emit('open')
}

export const closeSelectTemplateDialog = () => {
  evtBus.emit('close')
}
